/* eslint-disable */
// @ts-nocheck

import React from "react";
import { NumberInput, FormLabel } from "@carbon/react";
import FieldTooltip from "../tooltip/Tooltip";

interface IProps {
  label: string;
  placeholder?: string;
  max: number;
  min: number;
  disabled?: boolean;
  onChange: (value?: number) => void;
  value?: number;
  invalid?: boolean;
  invalidText?: string;
  tooltipText?: string;
  required?: boolean;
}

const getValue = (val?: number) => {
  if (val == 0) return 0;
  if (val) return val;

  return "";
};

const NumberField = ({
  label,
  placeholder,
  max,
  min,
  disabled = false,
  onChange,
  value,
  invalid = false,
  invalidText,
  tooltipText,
  required,
}: IProps) => {
  return (
    <div className="form-wrapper">
      <div className="form-label" data-cy="numberFieldform">
        <FormLabel data-cy={`${label.replaceAll(" ", "")}-numlabel`}>
          {label} {required == true ? "*" : null}
        </FormLabel>
        {tooltipText ? (
          <FieldTooltip
            fieldName={`${label.replaceAll(" ", "")}-`}
            label={tooltipText}
          />
        ) : null}
      </div>
      <NumberInput
        placeholder={placeholder || label}
        hideSteppers="False"
        disableWheel="False"
        max={max}
        min={min}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        value={getValue(value)}
        allowEmpty
        disabled={disabled}
        invalid={invalid}
        invalidText={invalidText}
        required={required}
        data-cy={`${label.replaceAll(" ", "")}-input`}
      />
    </div>
  );
};

export default NumberField;
